import React from 'react';
import { Text } from '@react-pdf/renderer';

export function getValidUrl(url: string | undefined): string | null {
  if (!url || url === 'ACTION_REQUIRED_URL') return null;
  const trimmed = url.trim();
  if (!trimmed.includes('.')) return null; 
  if (!/^https?:\/\//i.test(trimmed) && !/^mailto:/i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  return trimmed;
}

function parseBoldText(text: string): React.ReactNode[] {
  if (typeof text !== 'string') return [<Text key={0}>{text || ''}</Text>];
  const parts = text.split(/(\*\*[\s\S]*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      const boldText = part.substring(2, part.length - 2);
      return <Text key={index} style={{ fontFamily: 'Helvetica-Bold' }}>{boldText}</Text>;
    }
    return <Text key={index}>{part}</Text>;
  });
}

export function parseRichText(text: string, showChanges: boolean): React.ReactNode[] {
  if (typeof text !== 'string') return [<Text key={0}>{text || ''}</Text>];
  
  if (!showChanges) {
    let cleanText = text.replace(/<del>[\s\S]*?<\/del>/g, '');
    cleanText = cleanText.replace(/<\/?ins>/g, '');
    return parseBoldText(cleanText);
  }

  const regex = /(<del>[\s\S]*?<\/del>|<ins>[\s\S]*?<\/ins>|\*\*[\s\S]*?\*\*)/g;
  const parts = text.split(regex);
  
  return parts.filter(Boolean).map((part, index) => {
    if (part.startsWith('<del>') && part.endsWith('</del>')) {
      const content = part.substring(5, part.length - 6).replace(/\*\*/g, '');
      return <Text key={index} style={{ textDecoration: 'line-through', color: '#ef4444', backgroundColor: '#fef2f2' }}>{content}</Text>;
    }
    if (part.startsWith('<ins>') && part.endsWith('</ins>')) {
      const content = part.substring(5, part.length - 6);
      return <Text key={index} style={{ color: '#059669', backgroundColor: '#ecfdf5' }}>{parseBoldText(content)}</Text>;
    }
    if (part.startsWith('**') && part.endsWith('**')) {
      const content = part.substring(2, part.length - 2);
      return <Text key={index} style={{ fontFamily: 'Helvetica-Bold' }}>{content}</Text>;
    }
    return <Text key={index}>{part}</Text>;
  });
}
